export const USERNAME_MIN_LENGTH = 6;
export const USERNAME_MAX_LENGTH = 50;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 20;
export const EMAIL_LENGTH = 50;
export const NAME_LENGTH = 20;
export const FIRSTNAME_LENGTH = 20;
export const ADDRESS_LENGTH = 50;
export const POSTCODE_LENGTH = 6;
export const CITY_LENGTH = 50;
export const COUNTRY_LENGTH = 20;
export const PHONE_LENGTH = 20;
export const PHONE_NUMBER_LENGTH_MIN = 10;
export const PHONE_NUMBER_LENGTH_MAX = 17;
export const CONTACT_MESSAGE_LENGTH = 8000;
export const BIC_MAX_LENGTH = 11;
export const BIC_MIN_LENGTH = 8;

export const PASSWORD_REGEX = /^(?=^.{8,20}$)((?=.*[A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z]))^.*$/;
export const FILE_ACCEPTED_FORMAT = ['html', 'pdf', 'jpg', 'jpeg', 'doc', 'png', 'eml', 'docx'];
export const FLASHING_TICKET_ACCEPTED_FORMAT = ['jpg', 'png', 'jpeg', 'pdf'];



// WEBPACK FOOTER //
// ./src/constants/form.js